<agpr-dialog-container
    [id]="id + '_csvImportDialog'"
    [heading]="heading"
    (onHide)="cancel()"
>
    <input
        *ngIf="!csvColumns"
        type="file"
        accept=".csv"
        (change)="fileSelected($event)"
    >
    <div
        *ngIf="csvColumns && csvFields"
        class="agpr-csvimport-gridContainer"
    >
        <ng-container
            *ngFor="let field of csvFields; let i = index"
        >
            <span class="agpr-csvimport-fieldDropdowns">
                <agpr-dropdown
                    [id]="id + '_dropdown'"
                    [options]="csvColumnDropdownOptions"
                    [(ngModel)]="selectedOptions[i]"
                    (ngModelChange)="onDropdownChanged($event, field)"
                    [ariaLabel]="field.originalField.label"
                ></agpr-dropdown>
            </span>
            <span class="agpr-csvimport-fieldExamples">{{field.exampleValue}}</span>
        </ng-container >
    </div>

    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '_confirmDialog_cancel'"
            [label]="'cancel'"
            [disabled]="loading"
            (click)="cancel()"
            [style]="buttonTypes.secondary"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
            <agpr-button
                [id]="id + '_confirmDialog_ok'"
                [label]="'ok'"
                [disabled]="loading"
                (click)="ok()"
            >
            </agpr-button>
    </ng-template>
</agpr-dialog-container>
